import type { FC } from 'react';
import { Button } from '@/components/ui/button';
import { useTranslation } from '@/hooks/useTranslation';

interface MLRunButtonProps {
  status: 'idle' | 'running' | 'completed' | 'failed';
  disabled: boolean;
  onRun: () => void;
  onCancel: () => void;
}

export const MLRunButton: FC<MLRunButtonProps> = ({ status, disabled, onRun, onCancel }) => {
  const { t } = useTranslation();

  if (status === 'running') {
    return (
      <div className="flex gap-2">
        <Button loading className="flex-1" data-testid="run-button">
          {t('mlRul.context.runButtonLoading')}
        </Button>
        <Button variant="outline" onClick={onCancel} data-testid="cancel-button">
          {t('mlRul.context.cancelButton')}
        </Button>
      </div>
    );
  }

  if (status === 'failed') {
    return (
      <Button
        onClick={onRun}
        disabled={disabled}
        className="w-full"
        data-testid="run-button"
      >
        {t('mlRul.context.retryButton')}
      </Button>
    );
  }

  return (
    <Button
      onClick={onRun}
      disabled={disabled}
      className="w-full"
      data-testid="run-button"
    >
      {t('mlRul.context.runButton')}
    </Button>
  );
};
